import { EnvFeaturesEnum } from '@invivodf/front-seller-feature-flipping'

export const useMetaDiscountFeature = () => {
  const isActivated = window.env[EnvFeaturesEnum.DISCOUNT_META_FEATURE] === 'yes'

  return {
    isActivated,
  }
}
